import { Fragment } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SidebarLayout } from '@/components/layout'

export function MainLayout() {

  const location = useLocation();

  return (
    <Fragment>
      <SidebarLayout>
        <Outlet key={location.key}/>
      </SidebarLayout>
    </Fragment>
  )
}
